import React from 'react';
import { COLORS } from '../../constants';
import './Card.css';

export const Card = ({ children, style = {}, className = '' }) => (
  <div className={`prisma-card ${className}`} style={style}>
    {children}
  </div>
);

export const InfoCard = ({ title, children, icon }) => (
  <div className="prisma-info-card">
    <div className="info-card-header">
      {icon || (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={COLORS.primary} strokeWidth="2">
          <circle cx="12" cy="12" r="10" />
          <line x1="12" y1="16" x2="12" y2="12" />
          <line x1="12" y1="8" x2="12.01" y2="8" />
        </svg>
      )}
      {title}
    </div>
    <div className="info-card-body">{children}</div>
  </div>
);

export default Card;